module.exports = __webpack_public_path__ + "static/media/1623678037530_1635371988949.4223523d.jpeg";